module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "block",
    staticClass: "block-ellipsis"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d3a4544!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/block-ellipsis/index.vue
// module id = 2090
// module chunks = 2